import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { Config } from '../../../../config';

const initSubscriptionsMFEApiService = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { initSmApiService } = await import('subscriptions/initApiService');
    initSmApiService(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initSubscriptionsMFEApiService', e);
  }
};

export default initSubscriptionsMFEApiService;
